







import Vue from 'vue';
import Layout from '@/layouts/AuthLayout.vue';
import AuthPanel from './components/AuthPanel.vue';

export default Vue.extend({
    name: 'AuthPage',
    components: {
        Layout,
        AuthPanel,
    },
    metaInfo: {
        title: 'Вход в систему',
    },
});
